// Get and Set the custom ref for the location region name node

let regionNameRef = null
export const setRegionNameRef = ref => { regionNameRef = ref }
export const getRegionNameRef = () => regionNameRef
